import { b as ToastContext } from '../../useOrchard-4d335da4.js';
export { c as Toast, T as ToastProvider } from '../../useOrchard-4d335da4.js';
import * as React from 'react';
import '../../tslib.es6-ff7ae7b8.js';
import 'react-dom';
import '../../index-b0444989.js';
import 'react-spring';
import '../../countries-0aa398a1.js';
import './IconButton.js';
import '../../skeleton.module-58f87ef6.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-67118f52.js';
import '../../CircleAlertIcon-260aea89.js';
import '../../CloseIcon-ee1d8a9a.js';
import '../../InfoIcon-a2368fdb.js';
import '../../ThemeProvider-22ee39e3.js';

function useToast() {
    var context = React.useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be a child of ToastProvider");
    }
    return context;
}

export { useToast };
